export default {
  detail: {
    activite: "Détail de l'activité",
    mission: "Détail des missions",
  },
  information: {
    generale: "Information générale",
    mission: "Information détaillé",
  },
  cloture: "Clôturé ",
  cloturer: "Clôturer ",
  Consentement: "Consentement éclairé",
  missionCloture: "Cette mission est-elle Clôturée ?",
  activiteCloture: "Cette activité est-elle Clôturée ?",
  details: "Détail | détails",
  dateCloture: "Date de clôture",
  prispour: "pris pour la date du",
  commentaires: "Commentaire | Commentaires",
  groupeActivite: "Groupe d'activité",
  activite: {
    mission: {
      update: "Mission modifiée",
      add: "Mission ajoutée",
      delete: "Mission supprimée",
    },
    cloture: "Activité cloturé",
    create: "Activité crée",
    delete: "Activité supprimé",
    edit: "Activité modifié",
    titre: "Activité | Activités",
    ajoutDeClotureAMA: "clôture de la ligne de temps par l'AMA le ",
    affiliationDeClotureAMA: "Affiliation Cloturée par l'AMA le",
    nom: "Nom de l'activité",
    0: "Processus de suivi d’un Patient affilié",
    1: "Processus de suivi d’un Patient affilié – Medicasure à CHAUD (J1)",
    2: "Processus de suivi d’un Patient affilié – Medicasure à FROID     (Après l’évènement aigu à l’exception des consultations à domicile)",
    3: "Expansion du réseau – Partenaire Medicasure et Contrôle Qualité",
    4: "Promotion scientifique",
  },
  consultation: "Consultation",
  compteRendu: {
    operatoireCreated: "Compte rendu opératoire enregistré",
    operatoireDeleted: "Compte rendu opératoire supprimé",
    operatoireUpdated: "Compte rendu opératoire modifié",
    operatoireTransmit: "Compte rendu opératoire transmis",
    operatoireArchive: "Compte rendu opératoire archivé",
    operatoireReactiver: "Compte rendu opératoire réactivé",
  },
  mobile: {
    title: "Medsurlink Mobile",
    prestataire: "Prestataires médicaux",
    etablissement: "Etablissements",
  },
  traitementPostOperatoire: "Traitement post opératoire",
  descriptionIntervention: "Description de l'intervention",
  typeAnesthesie: "Type d'anesthésiste",
  circulant: "Circulant(s)",
  anesthesistes: "Anesthésiste(s)",
  aide: "Aide(s)",
  chirugiens: "Chirugien(s)",
  etablissementIntervention: "Etablissement d'intervention",
  typeIntervention: "Type d'intervention",
  dateIntervention: "Date d'intervention",
  prestationValide: "Prestation validée",
  prestationRejete: "Prestation rejétée",
  decede: "Décédé",
  nonDecede: "Non Décédé",
  patientDecede: "Patient décédé",
  cePatientEstDecede: "Cette personne est-elle bien décédée ? ",
  cePatientNEstDecede: "Vous voulez modifier le statut de ce patient ",
  importPrestation: "Importer prestations",
  imprimerProforma: "Imprimer une proforma",
  imprimerDefinitive: "Imprimer une facture définitive",
  comptableCreated: "Comptable créé avec succès",
  assistanteCreated: "Assistante créé avec succès",
  comptableUpdated: "Comptable modifié avec succès",
  assistanteUpdated: "Assistante modifié avec succès",
  comptableDeleted: "Comptable supprimé avec succès",
  assistanteDeleted: "Assistante supprimé avec succès",
  infoGenerale: "Informations générale de la facture",
  rappeler: "Rappeler",
  institution: "Etabissement",
  homme: "Homme",
  femme: "Femme",
  userNotFound: "Vous ne trouvez pas l'utilisateur",
  isComptable: "Est il comptable ?",
  mailEnvoye: "Mail envoyé",
  recouvrer: "Recouvrer",
  modifierFacture: "Modifier facture",
  totalPrixPrestation: "Prix Total prestation",
  detailsFacture: "Détails de la facture",
  detailsPrestation: "Détails de la prestation",
  ajouterDetail: "Ajouter détails",
  ajouterActivite: "Ajouter une Activité",
  enregistrerFacture: "Enregistrer facture",
  facture: "Facture | Factures",
  ajouterFacture: "Ajouter Une Facture",
  facturations: "Facturation | Facturations",
  EtablissementPrix: "Etablissement prix",
  amount: "Prix",
  totalHorsRemise: "Total hors remise",
  totalAvecRemise: "Total avec remise",
  remise: "Remise",
  paye_par_affilie: "Les soins seront payés par l'affilié",
  continuer: "Continuer",
  dateFacturation: "Date de facturation",
  datePrestation: "Date de prestation",
  ajouterALaListeDesFactures:
    "Ajouter la prestation à la liste des prestations",
  factureCreated: "Facture créé avec succès",
  AssignCreated: "Assignation créé avec succès",
  factureUpdated: "Facture modifié avec succès",
  factureDeleted: "Facture supprimé avec succès",
  nomEtablissement: "Nom d' établissement",
  nomPrestation: "Nom de la prestation",
  reduction: "Réduction",
  listeDesEtablissements: "Liste des établissements offrant ce service",
  nonDefinie: "Non définie",
  nomDeLaCategorie: "Nom de la catégorie",
  aucun: "Aucun | Aucune",
  autre: "Autre | Autres",
  addAutrePrestation: "Rajouter autre prestation",
  addAutreCategorie: "Rajouter autre catégorie",
  categoriePrestation: "Categorie de prestation",
  listeDesPrestations: "Liste des prestations",
  prestationCreated: "Prestation créé avec succès",
  prestationUpdated: "Prestation modifié avec succès",
  prestationDeleted: "Prestation supprimé avec succès",
  categorieCreated: "Catégorie créé avec succès",
  categorieUpdated: "Catégorie modifié avec succès",
  categorieDeleted: "Catégorie supprimé avec succès",
  prestation: "Prestation | Prestations",
  prestationDetail: "Details prestations",
  prestationEtablissement: "Prestations d' établissement",
  comptable: "Comptables",
  addInstitution: "Ajouter Un Etablissement",
  consultationExiste:
    "Vous ne trouvez pas votre type de consultation dans la liste ci-dessus",
  praticienExiste: "Vous ne trouvez pas le praticien dans la liste ci-dessus",
  consultationName: "Nom de la consultation / de la prestation",
  organiserRdv: "Désirez vous organiser un rendez vous pour ce patient?",
  fichiersExternes: "Fichiers médicaux externes",
  compteRenduOperatoire: "Compte rendu opératoire",
  addCompteRenduOp: "Ajouter Un Compte Rendu Opératoire",
  deleteLogo: "Supprimer logo",
  manuscrit: "Fichier externe",
  tailleMaximum:
    "Taille maximum des fichiers : 5 MB. Vous pouvez réduire la taille de vos fichier sur ce site :" +
    "https://www.wecompress.com/",
  rapport: "Rapport",
  adresse: "Adresse",
  quartier: "Quartier",
  dateFin: "Date de fin",
  voieAdmin: "Voie d'administration",
  par: "Par",
  nombre: "Nombre",
  nomDci: "nom DCI",
  nomSpecialite: "Nom spécialité",
  infoComp: "Information complémentaire",
  formulation: "Formulation",
  dose: "Dose",
  indicatif: "Indicatif telephonique",
  all: "Tous",
  addAll: "Tout ajouter",
  filtered: "Filtre",
  filter: "Rechercher un diagnostic (Anglais)",
  answer: "Réponse",
  secretQuestion: "Question secrète",
  niveauUrgence: "Niveau d'urgence",
  alreadySend: "SMS déjà envoyé",
  shallBeGenerate: "Un nouveau mot de passe sera généré et envoyé par sms.",
  smsSended: "SMS envoyé",
  labelLogin: "Numero de dossier ou email",
  listOfSubscribers: "Liste des souscripteurs",
  uploadSignature: "Uploader votre signature",
  isMedPatner: "Est il attaché à Medicasure ?",
  userIsNotice: "Est il practicien avis ?",
  abdoPerimetre: "Périmètre abdominal (cm)",
  cardiacExam: "Examen cardio",
  cardiacExamAdd: "Examen cardio ajouté avec succès",
  cardiacExamCreated: "Examen cardio créé avec succès",
  cardiacExamUpdated: "Examen cardio modifié avec succès",
  cardiacExamDeleted: "Examen cardio supprimé avec succès",
  abdominalPerimeter: "Abdominal perimeter",
  changeRole: "Changez de rôle",
  fileDeleted: "Fichier Supprimé avec succès",
  maxFileSize: "Taille maximum: 5 Mo",
  areYouSure: "Êtes vous sûr ?",
  yesLeave: "Oui, Quittez la page",
  unsaveData: "Les données non enregistrées seront perdues",
  disconnectMessage: "Déconnecté à cause de l'inactivite sur le site",
  tradeName: "Nom commercial",
  activeSubstance: "Principe actif",
  therapeuticClass: "Classe médicamenteuse",
  dosage: "Forme et dosage",
  packaging: "Conditionnement",
  drug: "Médicament | Médicaments",
  prescriptions: "Prescription | Prescriptions",
  prescription: "Prescription | Prescriptions",
  addPrescrip: "Ajouter Une Prescription",
  drugCreated: "Médicament créé avec succès",
  drugUpdated: "Médicament modifié avec succès",
  drugDeleted: "Médicament supprimé avec succès",
  prescriptionCreated: "Ordonnance créé avec succès",
  prescriptionUpdated: "Ordonnance modifié avec succès",
  prescriptionDeleted: "Ordonnance supprimé avec succès",
  contributors: "Contributeur | Contributeurs",
  iSymbol: "Inclure des symboles",
  iNumber: "Inclure des nombres",
  number: "Téléphone",
  iLoCase: "Inclure minuscules",
  iUpCase: "Include majuscules",
  iAmChar: "Include des caractères spéciaux",
  settings: "Paramètres",
  numberOfYear: "Nombre d'années",
  smokedPerDay: "Nombre de cigarette(s) fumé par jour",
  emptyUpload: "Réinitialiser",
  integer: "Saisissez des chiffres",
  reavivate: "Reactiver",
  nle_anle: "nle/anle",
  t1: "T1",
  nipt: "NIPT",
  biTest: "Bi-test",
  unknownDate: "Date inconnue",
  value: "Valeur",
  rcc: "RCC",
  tsh: "TSH",
  ft3: "FT3",
  ft4: "FT4",
  warning: "Attention",
  antiTpo: "ANTI TPO",
  emu: "EMU",
  infoSupported: "Information de prise en charge",
  glucose: "Glycémie",
  pcr: "PCR Gonocoque | PCR Chlamydia",
  listOfPatientInstitution: "Liste des établissements du patient",
  searchPatient: "Rechercher patient",
  preview: "Aperçu",
  listPatient: "Liste des patients ",
  backtap: "Retour",
  change: "Changer",
  unknownDateText:
    "Si né vers… Alors définir le 01.Janvier comme date de naissance. ",
  street: "Rue / Quartier",
  zipCode: "Code postal",
  date: "Date",
  institutionConsultation: "Etablissement de consultation",
  of: "de",
  logo: "Logo",
  familyStuation: "Situation familiale",
  tabac: "Tabac",
  alcool: "Alcool",
  nombreEnfant: "Nombre d'enfants",
  enfants: "Enfant | Enfants",
  autres: "Autre",
  marie: "Marrié(e)",
  celibataire: "Célibataire",
  signature: "Signature",
  consentement: "Consentement éclairé",
  addConsultation: "Ajouter consultation",
  print: "Imprimer",
  informations: "Informatation | Informations",
  infoConsultation: "Données de la consultation",
  infoPatient: "Données personnelles",
  infoAllergies: "Allergies",
  infoAntecedents: "Antécédents",
  copyrightText: "© 2019 Tous Droits Réservés.",
  loading: "Chargement...",
  home: "Accueil",
  copyright_internal_footer: "Tous droits réservés | Medsurlink by Medicasure ",
  by_medicasure: "Developpé par Medicasure",
  about: "A Propos",
  contact: "Contactez-Nous",
  login: "Connexion",
  connexion_formulaire: "Connectez-vous",
  register: "Inscription",
  account: "Profile",
  signature: "Signature",
  dashboard: "Tableau de Bord",
  SouscripteurDashboard: "Mes souscriptions",
  logout: "Déconnexion",
  readMore: "Savoir Plus",
  socialConnect: "Rejoignez-nous sur les réseaux sociaux!",
  genericError: "Une erreur s'est produite. Veuillez réessayer plus tard.",
  search: "Rechercher",
  email: "Email",
  password: "Mot de Passe",
  searchResults: "Résultats de recherche",
  currency: "XAF",
  noResults: "Rien à afficher",
  cancel: "Annuler",
  firstName: "Prénom",
  lastName: "Nom",
  phoneNumber: "Numéro de Téléphone",
  sla: "Sélectionner l'activité",
  gender: "Genre",
  decede: "Décédé",
  male: "Masculin",
  female: "Féminin",
  dob: "Date de Naissance",
  selectAvatar: "Choisir Avatar",
  avatar: "Avatar",
  passwordConfirm: "Confirmer Mot de Passe",
  requiredField: "Ce champ est obligatoire",
  emailNotValid: "L'adresse email n'est pas valide",
  minCharacters: "Min {n} caractères",
  maxCharacters: "Max {n} caractères",
  passwordsDontMatch: "Les mots de passe ne correspondent pas",
  add: "Ajouter",
  list: "Liste",
  bought: "Achetés",
  sold: "Vendus",
  profile: "Profil",
  view: "Afficher",
  edit: "Modifier",
  delete: "Supprimer",
  guidelines: "Directives",
  types: "Type | Types",
  price: "Prix",
  yes: "Oui",
  no: "Non",
  submit: "Envoyer",
  users: "Utilisateur | Utilisateurs",
  createdAt: "Date/Heure d'ajout",
  roles: "Rôle | Rôles",
  operations: "Opération | Opérations",
  name: "Nom",
  userCreated: "Utilisateur créé avec succès",
  userUpdated: "Utilisateur modifié avec succès",
  userDeleted: "Utilisateur supprimé avec succès",
  rdvCreated: "Rendez-vous créé avec succès",
  rdvUpdated: "Rendez-vous crée avec succès",
  rdvDeleted: "Rendez-vous supprimé avec succès",
  partnerCreated: "Partenaire créé avec succès",
  partnerUpdated: "Partenaire modifié avec succès",
  partnerDeleted: "Partenaire supprimé avec succès",
  countries: "Pays de résidence | Pays",
  rgpd: "rgpd",
  partners: "Partenaire | Partenaires",
  addPartners: "Ajouter un Partenaire",
  generalInfo: "Informations Générales",
  accountInfo: "Informations du Compte",
  denominations: "Dénomination | Dénominations",
  address: "Adresse",
  voirrecu: "Voir le reçu de paiement",
  city: "Ville",
  profession: "Profession",
  specialty: "Spécialité",
  workSite: "Etablissement d'exercice",
  workSiteStreet: "Rue/Quartier d'établissement d'exercice",
  workSiteCity: "Ville d'établissement d'exercice",
  workSiteCountry: "Pays Etablissement",
  orderNumber: "Numéro d'Ordre",
  website: "Site Internet",
  socialNetwork: "Réseau Social",
  gotMedicalSecretary: "Disposez-vous d'un(e) sécrétaire medical(e)?",
  gotItTools: "Disposez-vous des outils informatiques ?",
  gotInternet: "Disposez-vous d'une connexion internet ?",
  gotParkingSpace: "Disposez-vous d'un parking ?",
  appointments: "Rendez-vous",
  logoutSuccess: "Vous vous êtes déconnecté avec succès",
  previous: "Précédent",
  next: "Suivant",
  subject: "Objet",
  time: "Heure",
  emailHint: "(le rendez-vous vous sera transmis à cette adresse)",
  whatsappNumber: "Numéro WhatsApp",
  skype: "Skype",
  LigneTempsActiviteMedecinReferent:
    "Ligne de temps des activités Medecin Referent",
  enterAtLeastOneNumber:
    "Entrez au moins un numero WhatsApp, numero de téléphone ou ID Skype",
  appointmentMade: "Rendez-vous effectué avec succès",
  appointmentUpdated: "Rendez-vous modifié avec succès",
  appointmentCanceled: "Rendez-vous annulé avec succès",
  appointmentDeleted: "Rendez-vous supprimé avec succès",
  nomEtPrenomSouscripteur: "nom et Prénom du souscripteur",
  nomEtPrenom: "Nom et prénom",
  dates: "Date | Dates",
  date_heure: "Date et Heure",
  status: "Statut",
  actions: "Action | Actions",
  qCountries: "Selectionner votre pays de résidence",
  qTypes: "Selectionner le style d'entretien",
  qSubject: "Sujet de l'entretien",
  qTime1: "1ère plage horaire de l'entretien",
  qTime2: "2e plage horaire de l'entretien",
  qName: "Votre nom",
  qEmail: "Votre email",
  contracts: "Contrat | Contrats",
  pickAtLeastTwoDates: "Choisissez au moins deux (2) plages horaires",
  pickOtherTimeSlot: "Choisissez une autre heure",
  bookAgain: "Effectuer un autre rendez-vous",
  contractMade: "Contrat créé avec succès",
  contractSent: "Contrat envoyé avec succès",
  contractUpdated: "Contrat modifié avec succès",
  contractDeleted: "Contrat supprimé avec succès",
  titles: "Titre | Titres",
  cities: "Ville de résidence | Ville",
  nomSouscripteur: "Nom du souscripteur",
  informationPatien: "Information du patient",
  paysSouscripteur: "Pays du souscripteur",
  villeSouscripteur: "Ville du souscripteur",
  phone1Souscripteur: "Numéro de téléphone principal du souscripteur",
  phone2Souscripteur: "Numéro de téléphone secondaire du souscripteur",
  email1Souscripteur: "Adresse email principale du souscripteur",
  email2Souscripteur: "Adresse email secondaire du souscripteur",
  typeSouscription: "Type de souscription",
  paysSouscription: "Pays de souscription",
  sexeSouscripteur: "Sexe du souscripteur",
  sexe: "Sexe",
  nomPartenaire: "Nom du partenaire",
  prenomPartenaire: "Prénom du partenaire",
  sexePartenaire: "Sexe du partenaire",
  nomAffiliation: "Nom de l'affiliation",
  sexeAffiliation: "Sexe de l'affiliation",
  ageAffiliation: "Age de l'affiliation",
  paysAffiliation: "Pays de l'affiliation",
  lieuEtablissement: "Lieu de l'établissement de l'affiliation",
  villeAffiliation: "Ville de l'affiliation",
  annivAffiliation: "Date de naissance de l'affilié",
  phone1Affiliation: "Numéro de téléphone principal de l'affilié",
  phone2Affiliation: "Numéro de téléphone secondaire de l'affilié",
  phone1Contact: "Numéro de téléphone principal du contact",
  phone2Contact: "Numéro de téléphone secondaire du contact",
  nomContact: "Nom du contact",
  telephone: "Numéro",
  nomPractitioners: "Nom du practicien",
  nomPatient: "Nom du patient",
  montantSouscription: "Montant sousscription",
  dateSignature: "Date de la signature",
  offres: "Offre | Offres",
  created_at: "Date de création",
  entreprise: "Entreprise",
  prospect_assurances: "Prospect Assurances",
  offerList: {
    "one-shot": "One shot",
    annuelle: "Annuelle",
  },
  permissions: "Permission | Permissions",
  diagnosticselectionner: "Selectionné(s) un diagnostic(s)",
  latest: "Plus récents",
  oldest: "Plus anciens",
  none: "Aucun",
  downloadPdf: "Télécharger PDF",
  send: "Envoyer",
  resend: "Renvoyer",
  addSubscriber: "Ajouter Souscripteur",
  subscribers: "Souscripteur | Souscripteurs",
  nationality: "Nationalité",
  reset: "Réinitialiser",
  subscriberCreated: "Souscripteur créé avec succès",
  subscriberUpdated: "Souscripteur modifié avec succès",
  subscriberDeleted: "Souscripteur supprimé avec succès",
  managers: "Gestionnaire | Gestionnaires",
  civility: "Civilité",
  managerCreated: "Gestionnaire créé avec succès",
  managerUpdated: "Gestionnaire modifié avec succès",
  managerDeleted: "Gestionnaire supprimé avec succès",
  patients: "Patient | Patients",
  patientCreated: "Patient créé avec succès",
  patientUpdated: "Patient modifié avec succès",
  patientDeleted: "Patient supprimé avec succès",
  professions: "Profession | Professions",
  professionCreated: "Profession créée avec succès",
  professionUpdated: "Profession modifiée avec succès",
  professionDeleted: "Profession supprimée avec succès",
  specialties: "Spécialité | Spécialités",
  specialtyCreated: "Spécialité créée avec succès",
  specialtyUpdated: "Spécialité modifiée avec succès",
  specialtyDeleted: "Spécialité supprimée avec succès",
  controlDoctors: "Médecin Contrôle | Médecins Contrôles",
  addControlDoctors: "Ajouter Médecin Contrôle",
  controlDoctorCreated: "Médecin contrôle créé avec succès",
  controlDoctorUpdated: "Médecin contrôle modifié avec succès",
  controlDoctorDeleted: "Médecin contrôle supprimé avec succès",
  institutions: "Etablissement | Etablissements",
  institutionCreated: "Etablissement créé avec succès",
  institutionUpdated: "Etablissement modifié avec succès",
  institutionDeleted: "Etablissement supprimé avec succès",
  description: "Description",
  practitioners: "Praticien | Praticiens",
  addPractitioners: "Ajouter un Practicien",
  practitionerCreated: "Praticien créé avec succès",
  practitionerUpdated: "Praticien modifié avec succès",
  practitionerDeleted: "Praticien supprimé avec succès",
  userManagement: "Gestion des Utilisateurs",
  activiteManagement: "Gestion des activités",
  medicalManagement: "Dossier médical",
  consultations: "Consultation | Consultations",
  obstetricConsultations:
    "Consultation Obstétrique | Consultations Obstétriques",
  prenatalConsultations: "Consultation Prenatale |  Consultations Prenatales ",
  generalConsultations:
    "Consultation Médecine Générale | Consultations Médecines Générale",
  editGeneratlConsul: "Modifier Une Consultation Médecine Générale",
  typeResultat: "Type de Résultat",
  teleConsultations: "Télé - Hétéro Consultation | Télé - Hétéro Consultations",
  cardiologyConsultations: "Consultation Cardiologique",
  cardiologyConsultationsCreated: "Consultation Cardiologique créé avec succès",
  cardiologyConsultationsUpdated:
    "Consultation Cardiologique modifié avec succès",
  cardiologyConsultationsDeleted:
    "Consultation Cardiologique supprimé avec succès",
  cardiologyConsultationArchieved:
    "Consultation Cardiologique archivée avec success",
  cardiologyConsultationTransmitted:
    "Consultation Cardiologique transmise avec success",
  manuscritConsultations: "Fichier externe",
  addManuscritConsul: "Ajouter Un Fichier Externe",
  manuscritConsultationsCreated: "Fichier externe crée avec succès",
  manuscritConsultationsUpdated: "Fichier externe modifié avec succès",
  manuscritConsultationsDeleted: "Fichier externe supprimé avec succès",
  manuscritConsultationArchieved: "Fichier externe archivé avec success",
  manuscritConsultationTransmitted: "Fichier externe transmis avec success",
  manuscritConsultationReactived: "Fichier externe réactivée avec success",
  dermatologyConsultations: "Consultation Dermatologique",
  endocrinologyConsultations: "Consultation Endocrinologique",
  gastroenterologyConsultations: "Consultation Gastroentérologique",
  geriatricsConsultations: "Consultation Geriatrique",
  hématologieConsultations: "Consultation Hématologique",
  internalMedicineConsultations: "Consultation Medicine Interne",
  nephrologyConsultations: "Consultation Néphrologique",
  neurologyConsultations: "Consultation Neurologique",
  ophthalmologyConsultations: "Consultation Ophtalmologique",
  oncologyConsultations: "Consultation Oncologique",
  earNoseThroatConsultations: "Consultation Oto-rhino-laryngologique",
  pediatricsConsultations: "Consultation Pédiatrique",
  pneumologyConsultations: "Consultation Pneumologique",
  psychiatryConsultations: "Consultation Psychiatrique",
  rheumatologyConsultations: "Consultation Rhumatologique",
  stomatologyConsultations: "Consultation Stomatologique",
  teleConsultations: "Télé - Hétéro Consultation",
  treatments: "Traitement | Traitement",
  Medical_Administrative_Pathways: "Parcours Médico-Administratifs",
  Parcours_activités_Medecin_Contrôle: "Parcours activités Medecin Contrôle",
  Parcours_médicaux_et_financiers: "Parcours médicaux et financiers",
  Bilans: "Bilans",
  treatmentCreated: "Traitement créé avec succès",
  treatmentUpdated: "Traitement modifié avec succès",
  treatmentDeleted: "Traitement supprimé avec succès",
  allergies: "Allergie | Allergies",
  addAllergies: "Ajouter une Allergie",
  allergyCreated: "Allergie créée avec succès",
  allergyUpdated: "Allergie modifiée avec succès",
  allergyDeleted: "Allergie supprimée avec succès",
  adminManagement: "Gestion Administrative",
  medicalFiles: "Dossier Médical",
  numeroDossier: "N° dossier: ",
  medicalFileCreated: "Dossier médical créé avec succès",
  medicalFileUpdated: "Dossier médical modifié avec succès",
  medicalFileDeleted: "Dossier médical supprimé avec succès",
  physicalExams: "Examen Clinique | Examen(s) Clinique(s)",
  physicalExamCreated: "Examen clinique créé avec succès",
  physicalExamUpdated: "Examen clinique modifié avec succès",
  physicalExamDeleted: "Examen clinique supprimé avec succès",
  complementaryExams: "Examen Complémentaire | Examen(s) Complémentaire(s)",
  complementaryExamCreated: "Examen complémentaire créé avec succès",
  complementaryExamUpdated: "Examen complémentaire modifié avec succès",
  complementaryExamDeleted: "Examen complémentaire supprimé avec succès",
  references: "Réference | Réferences",
  affiliations: "Affiliation | Affiliations",
  editAffiliation: "Modifier une Affiliation",
  affiliationCreated: "Affiliation créée avec succès",
  affiliationUpdated: "Affiliation modifiée avec succès",
  affiliationDeleted: "Affiliation supprimée avec succès",
  reasons: "Motif | Motifs",
  reasonCreated: "Motif créée avec succès",
  reasonUpdated: "Motif modifiée avec succès",
  reasonDeleted: "Motif supprimée avec succès",
  startDate: "Date de début",
  endDate: "Date de fin",
  appointmentDate: "Date du rendez-vous",
  appointmentReason: "Motif du rendez-vous",
  creationDate: "Date de création",
  pregnancyNumber: "Numéro de grossesse",
  serology: "Sérologie",
  bloodGroup: "Groupe sanguin",
  familyStatus: "Statut socio familiale",
  addictions: "Assuétude | Assuétudes",
  transfusionAntecedent: "Antécédent de transfusion",
  riskFactor: "Facteur de risque",
  add_souscripteur: "Ajout souscripteur",
  obstetricConsultationCreated: "Consultation obstétrique créée avec succès",
  obstetricConsultationUpdated: "Consultation obstétrique modifiée avec succès",
  obstetricConsultationDeleted:
    "Consultation obstétrique supprimée avec succès",
  ultrasounds: "Echographie | Echographies",
  ultrasoundCreated: "Echographie créée avec succès",
  ultrasoundUpdated: "Echographie modifiée avec succès",
  ultrasoundDeleted: "Echographie supprimée avec succès",
  amenorrheaWeek: "Semaine aménorrhée",
  dpa: "Date prévue d'accouchement",
  prenatalConsultationCreated: "Consultation prenatal créée avec succès",
  prenatalConsultationUpdated: "Consultation prenatal modifiée avec succès",
  prenatalConsultationDeleted: "Consultation prenatal supprimée avec succès",
  typeOfConsultation: "Type de consultation",
  typeOfUltrasound: "Type d'echographie",
  complaints: "Plainte | Plaintes",
  addComplaints: "Ajouter une nouvelle plainte",
  selectAffiliation: "Sélectionnez l'affiliation",
  bilanGlobal: " Bilan global Assuré",
  bilanFinancier: "Mon bilan Financier",
  antecedentSpouse: "Antécédent conjoint",
  recommendations: "Recommandation | Recommandations",
  archievedAt: "Archivé le",
  passedAt: "Transféré le",
  fileNumber: "Numero de dossier",
  hospitalisations: "Hospitalisation | Hospitalisations",
  addHospitalisation: "Ajouter Une Hospitalisation",
  hospitalisationCreated: "Hospitalisation créée avec succès",
  hospitalisationUpdated: "Hospitalisation modifiée avec succès",
  hospitalisationDeleted: "Hospitalisation supprimée avec succès",
  entryDate: "Date d'entrée",
  exitDate: "Date de sortie",
  clinicalHistory: "Histoire clinique",
  lifestyle: "Mode de vie",
  evolution: "Evolution",
  parameter: "Paramètres",
  conclusion: "Diagnostic",
  avis: "Avis",
  exitTreatment: "Traitement de sortie",
  nameAndFileNumber: "Nom et numero de dossier",
  prenatals: "Prenatale | Prenatales",
  reference: "Reference",
  generalConsultationCreated:
    "Consultation médecine générale créée avec succès",
  generalConsultationUpdated:
    "Consultation médecine générale modifiée avec succès",
  generalConsultationDeleted:
    "Consultation médecine générale supprimée avec succès",
  anamnesis: "Anamnèse",
  consultationDate: "Date de consultation",
  weight: "poids (Kg)",
  taSystolique: "TA systolique (mmHg)",
  taDiastolique: "TA diastolique (mmHg)",
  taSystoliqueL: "TA systolique (mmHg) bras gauche",
  taDiastoliqueL: "TA diastolique (mmHg) bras gauche",
  taSystoliqueD: "TA systolique (mmHg) bras droit",
  taDiastoliqueD: "TA diastolique (mmHg) bras droit",
  urineHeight: "Hauteur Urine",
  touchVaginal: "Toucher vaginal",
  heartNoise: "Bruit du coeur",
  obstetricParameters: "Parametre obstetrique | Parametres obstetrique",
  obstetricConsultationArchieved: "Consultation obstétrique archivée success",
  obstetricConsultationTransmitted:
    "Consultation obstétrique transférée avec success",
  archieve: "Archiver",
  transmit: "Transmettre",
  obstetricParameterCreated: "Paramètre obstétrique créé avec succès",
  obstetricParameterUpdated: "Paramètre obstétrique modifié avec succès",
  obstetricParameterDeleted: "Paramètre obstétrique supprimé avec succès",
  remove: "Enlever",
  antecedents: "Antécédent | Antécédents",
  addAntecedent: "Ajouter un Antécédent",
  antecedentCreated: "Antécédent créé avec succès",
  antecedentUpdated: "Antécédent modifié avec succès",
  antecedentDeleted: "Antécédent supprimé avec succès",
  exams: "Examen | Examens",
  examsCom: "EXAMENS COMPLEMENTAIRES",
  prenatalConsultationArchieved: "Consultation prenatal archivée avec success",
  prenatalConsultationTransmitted:
    "Consultation prenatal transmise avec success",
  complementaryExamAdded: "examens complémentaires ajoutés avec success",
  complementaryExamRemoved: "examens complémentaires retirés avec success",
  physicalExamAdded: "examens cliniques ajoutés avec success",
  physicalExamRemoved: "examens cliniques retirés avec success",
  select: "Selectionner",
  or: "Ou",
  conclusions: "Diagnostic | Conclusions",
  conclusionCreated: "Diagnostic créé avec succès",
  conclusionUpdated: "Diagnostic modifié avec succès",
  conclusionDeleted: "Diagnostic supprimé avec succès",
  commonParameters: "Paramètre Commun | Paramètres Communs",
  commonParameterCreated: "Paramètre commun créé avec succès",
  commonParameterUpdated: "Paramètre commun modifié avec succès",
  commonParameterDeleted: "Paramètre commun supprimé avec succès",
  height: "Taille (cm)",
  results: "Résultat | Résultats",
  resultCreated: "Résultat créé avec succès",
  resultUpdated: "Résultat modifié avec succès",
  resultDeleted: "Résultat supprimé avec succès",
  uploadFile:
    "Charger un document (Résultat - Carnet - Photo - etc.) de 5Mo Maximale",
  uploadFile_1:
    "Charger un document (Résultat - Carnet - Photo - etc.) de 5Mo Maximale",
  uploadFile_2: "Charger un document(5Mo Max)",
  laboratory: "Laboratoire",
  imagery: "Imagerie",
  labResults: "Résultat de Laboratoire | Résultats de Laboratoire",
  addLabResults: "Ajouter Un Résultat de Laboratoire",
  imageryResults: "Résultat d'Imagerie | Résultats d'Imagerie",
  addImageryRes: "Ajouter Un Résultat d'Imagerie",
  currentTreatments: "Traitement actuel",
  addCurrentTreatment: "Ajouter Traitement actuel",
  currentTreatmentsCreated: "Traitement actuel ajouté avec succès",
  currentTreatmentsUpdated: "Traitement actuel modifié avec succès",
  currentTreatmentsDeleted: "Traitement actuel supprimé avec succès",
  prescriptionDate: "Date de prescription",
  fileManager: "Gestionnaire de Fichiers",
  medecineConsultationArchieved: "Consultation medecine archivée avec success",
  medecineConsultationTransmitted:
    "Consultation medecine transmise avec success",
  medecineConsultationReactived: "Consultation medecine reactivé avec success",
  obstetriqueConsultationReactived:
    "Consultation obstetrique reactivé avec success",
  reslutArchieved: "Resultat archivé avec success",
  reslutTransmitted: "Resultat transmis avec success",
  hospitalisationArchieved: "Hospitalisation archivée avec success",
  hospitalisationTransmitted: "Hospitalisation transmise avec success",
  kinesitherapyConsultationArchieved: "Kinesithérapie archivée avec succès",
  kinesitherapyConsultationTransmitted: "Kinesithérapie transmise avec succès",
  suggestTreatment: "Conduite à tenir",
  ddr: "Date des dernieres menstrues",
  biometric: "Biometrie",
  annex: "Annexe",
  bmi: "Bmi (kg/m²)",
  temperature: "Température (°C)",
  heartRate: "Fréquence cardiaque (bpm)",
  respiratoryRate: "Fréquence respiratoire (cpm)",
  sato2: "sato2 (%)",
  practionerDashboard: "Tableau de bord praticien",
  praticien: "Praticien | Praticien",
  listPatientPerInstitution: "Liste des patients par établissement",
  previousOperations: "Précedentes opérations",
  action: "Actions",
  listOfAffilaites: "Liste des nouveaux affiliés",
  listOfAffilaitesOld: "Liste des anciens affiliés",
  addAffilies: "Ajouter vos affiliés",
  detailAffiliation: "Voir les détails",
  old: "Age",
  affiliated: "Affilié(e) | Affilie(e)s",
  more: "Plus",
  obstetric: " Obstétrique",
  prenatal: " Prenatale",
  general: " Médecine Générale",
  cardiology: " Cardiologique",
  dermatology: " Dermatologique",
  endocrinology: " Endocrinologique",
  gastroenterology: " Gastroentérologique",
  geriatrics: " Geriatrique",
  hématologie: " Hématologique",
  internalMedicine: " Medicine Interne",
  nephrology: " Néphrologique",
  neurology: " Neurologique",
  ophthalmology: " Ophtalmologique",
  oncology: " Oncologique",
  earNoseThroat: " Oto-rhino-laryngologique",
  pediatrics: " Pédiatrique",
  pneumology: " Pneumologique",
  psychiatry: " Psychiatrique",
  rheumatology: " Rhumatologique",
  stomatology: " Stomatologique",
  tele: "Téléconsultations ",
  save: "Enregistrer",
  addConsul: "Ajouter Consultation Médecine Générale",
  show: "Voir",
  showCalendar: "Mode calendrier",
  showTable: "Mode tableau",
  reprogrammed: "Reprogrammé",
  deleteConfirmation: "Voulez-vous vraiment le supprimer ?",
  cancelConfirmation: "Voulez-vous vraiment l'annulé ?",
  followUp: "Suivi",
  followUpPatient: "Suivi des patients",
  followedUpCreated: "Suivie crée avec succès",
  followedUpUpdated: "Suivie modifié avec succès",
  followedUpDeleted: "Suivie supprimé avec succès",
  state: "etat | etats",
  pending: "en attente",
  ongoing: "en cour",
  closing: "en clôture",
  manager: "responsable",
  isConsultantDoctor: "Serez-vous le medecin consultant ?",
  medecin: "medecin",
  fromMedicasure: "De Medicasure",
  fromOthers: "D'autres",
  preciseDoctorName: "Precisez le nom du medecin",
  preciseEtablissementrName: "Precisez le nom de l'établissement",
  doctorName: "Nom du médecin",
  medicaleFolder: "Dossier medical",
  moveQuestion: "Vers où voulez-vous le deplacer ?",
  medicalAdvice: "Avis Médicaux",
  addMedicalAdvice: "Ajouter Avis Médicaux",
  objectAdvice: "Objet de la demande d'avis",
  doctorsAdvice: "Selectionner le/les médecins",
  bindToPatientMedicalFolder: "Lier au dossier médical du patient",
  boundToPatientMedicalFolder: "Lié au dossier médical du patient",
  notBoundToPatientMedicalFolder: "Non lié au dossier médical du patient",
  medicalAdviceCreated: "Avis medical créé avec succès",
  medicalAdviceUpdated: "Avis medical modifié avec succès",
  medicalAdviceDeleted: "Avis medical supprimé avec succès",
  adviceResponseSent: "Réponse à l'avis medical a été envoyé avec succès",
  doctorsResponse: "Les réponses des medecins",
  noResponseForTheMoment: "Pas de réponses pour le moment",
  response: "Répondre",
  responded: "Répondu",
  notResponded: "Pas Répondu",
  viewed: "Vu",
  notViewed: "Pas vu",
  validateResponse: "Validé la réponse",
  edited: "Edité",
  effectuer: "Marquer comme Effectuer",
  reprogrammer: "Reprogrammer",
  from: "de",
  validated: "validé",
  noResponseOfMedicalAdviceValidated: "No response of medical advice validated",
  category: "Categorie | Categories",
  noItem: "Pas d'éléments",
  noSearchResult: "Aucun resultat de recherche",
  todoList: "Liste des tâches",
  ok: "Ok",
  todoItemCreated: "Element todo créé avec succès",
  todoItemDeleted: "Element todo supprimé avec succès",
  addDescriptionHere: "Ajoutez une description içi",
  emergencyCode: "Code d'urgence",
  normal: "Normal",
  urgent: "Urgent",
  ultraUrgent: "Ultra urgent",
  and: "et",
  noItemToDisplay: "Pas d'élements à afficher",
  consult: "Consulter",
  sortBy: "Triez par",
  kinesitherapie: "kinésithérapie",
  kinesitherapyConsultations: "Consultation Kinesitherapie",
  evaluationGlobale: "Evaluation globale",
  conduiteATenir: "Conduite à tenir",
  impressionDiagnostique: "Impression diagnostique",
  examensComplementaires: "Complementary examination",
  conduite: "Conduite",
  kinesitherapyConsultationsUpdated: "Kinesitherapy mis à jour avec succès",
  region: "Region",
  personContact: "Personne de contact",
  partner: "Partenaire",
  Partners: "Partenaire",
  addPatient: "Ajouter les infromations de votre proche",
  addWebPatient: "Ajouter un patient",
  canCreatePatient: "Vous ne pouvez plus Ajouter un patient ",
  referenceDuPaiement: "Reference du paiement ",
  Paie: "Payer",
  acheterUneAffiliation: "Acheter une cim",
  code: "Indicatif",
  emailUsed: "Votre adresse email souscripteur sera utilisée par défaut",
  back: "Ressayer",
  completeProfile: "Completer votre profile",
  PaiementSuccess: "Confirmation de paiement",
  welcomeToMedicasure: "Bienvenue sur Medsurlink by Medicasure",
  paiementError:
    "Nous sommes désolés le paiement n'a pas abouti, veuillez ressayer",
  errorTitle: "Erreur de paiement",
  mesPatient: "Mes patients",
  factureAvis: "Facture avis",
  association: "Association",
  associations: "Associations",
  addAssociation: "Ajouter une Association",
  addFollowUp: "Ajouter Un Suivi",
  medecinPatient: "Medecin/patient",
  medecinReferent: "Medecin Referent",
  medecinreferent: "medecin Referent",
  medecinDossier: "Medecin patients",
  payment: "Paiement",
  motif: "Motif",
  Prospects: "Prospects",
  paymentConfirmation: "Confirmation de paiement",
  motifPayment: "Paiement Prestation",
  procederAuPaiement: "Procéder au paiement",
  PaiementPrestation: "Prestations",
  paymentManagement: "Gestion des paiements",
  paymentPrestation: "Paiement des prestations",
  paymentCim: "Paiement vers CIM",
  payments: "Paiements",
  paymentLink: "Lien de paiement",
  souscripteur: "Souscripteur",
  amountEURO: "Montant (EURO)",
  amount: "Montant",
  Editpayment: "Modifier payment",
  paymentDeleted: "Facture prestation supprimée",
  slack: "ID slack",
  AddPatientMessage:
    "Nous vous prions de renseingner les informations de vos patients pour qu'il puisse bénéficier immédiatement de leur prise en charge.",
  followUpSouscripteur: "Souscripteur CIM",
  nombreRestant: "CIM Restant",
  nombrePaye: "CIM Payé",
  rappel: "Rappel",
  patient: "Patient",
  gestionPatient: "Gestion Patients",
  patientMedecinControl: "Patient & medecin réferent",
  circonferenceAbdominal: "Circonférence abdominale (cm)",
  circonferenceCranienne: "Circonférence cranienne (cm)",
  glycemie: "Glycémie (mg/dL)",
  glycated: "Hémoglobine Glyquée (%)",
  cholestorol: "Cholestérol total (mg/dL)",
  hdl: "HDL (mg/dL)",
  ldl: "LDL (mg/dL)",
  tags: "Triglycérides (mg/dL)",
  examenclinique: "Examen clinique",
  diagnostic: "Diagnostic",
  diagnostic_dif: "Diagnostic différentielle",
  cat: "CAT",
  rdv: "RDV",
  cim: "Offre",
  Lien: "Lien de parenté",
  infosupplementaire: "Info supplémentaire",
  generale: "Information générale",
  anthropometrie: "Anthropométrie",
  signevitaux: "Signes vitaux",
  nutrition: "Nutrition",
  malnutrition: "Mal nutrition",
  deshydradation: "Déshydratation",
  lipide: "Lipide",
  ama: "Ama",
  aucunedonnee: "Aucune donnée",
  examencomplementaire: "Examens Complémentaires",
  saveAllergie: "Enregistrer",
  Addcomptable: "Ajouter un comptable a un établissement",
  paymentsCim: "Paiement de CIM",
  activity: "Activité",
  activities: "Activités",
  dateactivity: "Date activité",
  voirSouscripteur: "afficher souscripteur",
  assistante: "Assistante",
  listAssistante: "Liste des assistantes",
  selectMontant: "Selectionner le montant",
  dateValidation: "Date Validation Medicasure | Date Validation Souscripteur",
  clotureLigneTemps:
    "clôture de la ligne de temps par le Medécin Reférentclôture de la ligne de temps par le Medécin Reférent",
  TrajetPatientComplet: "TRAJETS PATIENT COMPLETS",
  Trajet: "Parcours de soins",
  trajetAMA: "Historique des activités Médico-administratives (AMA)",
  activiteAdminIs: "Activités Administratives Isolées",
  diagnosticMedPrac: "Etablissement du diagnostic par le médecin Praticien",
  activiteAdminAuto: "Activités Administratif Automatiques",
  activiteManAdmi: "Activités Manuelles Administratives",
  LigneTempsActivitéAMA: "Ligne de temps activités AMA",
  LigneTempsMedicofinanciere: "Ligne de temps Médicales + Financières",
  EtatfinContrat: "Bilans",
  infosouscription: "Information de souscription",
  ligneTempsMedFinan: "Ligne de temps médicales et financières",
  enregistreractivity: "Enregistrer l'activité",
  Addligne: "Ajouter une ligne de temps",
  Editligne: "Modifier une ligne de temps",
  Timeline: "Ligne de temps",
  TimelineCreated: "Ligne de temps créée avec succès",
  TimelineUpdated: "Ligne de temps modifiée avec succès",
  TimelineDeleted: "Ligne de temps supprimée avec succès",
  toDo: "A faire",
  doing: "En cours",
  listMedecinControl: "LISTE PATIENT & MEDECIN RÉFERENT",
  takeCare: "Délais Prises en Charges",
  takeCareMetrique: "Détails des metriques",
  TimelineSelect: "Selectionner une ligne de temps",
  commandecim: "List of commands",
  mesAffilie: "Mes affiliés",
  subscribe: "Souscrire",
  debutAffiliation: "Début Affiliation",
  finAffiliation: "Fin Affiliation",
  lienParente: "Lien Parenté",
  produit: "Affiliation",
  affilie: "Affilié",
  informationContrat: "Informations de l'affiliation",
  informationAffilie: "Informations de l'affilié",
  donneesAffiliation: "Données sur l'affiliation",
  renouvelle: "Renouveler",
  prolonger: "Prolonger affiliation",
  resilierContrat: "Résiliation",
  affiliation: "Affiliation",
  affiliations: "Affiliations",
  gestionaffiliation: "Gestion affiliations",
  urgence: "Urgence",
  package: "Package",
  souscription: "Souscription",
  paymentMedicasure: "Paiement affiliations",
  datePayment: "Date paiement",
  medicalFile: "Dossier médical",
  statusPaiement: "statut paiement",
  montantAffiliation: "Montant de l'affiliation",
  SubscriptionCanceled: "Souscription résiliée",
  mesfactures: "Mes factures",
  explication:
    "Affiliez via ce formulaire, votre patient bénéficiaire de l'offre",
  cimend:
    "Veuillez créditer votre compte afin de souscrire à une nouvelle affiliation",
  clickaffiliate: "Cliquez sur un affilié pour voir les détails",
  maintenance:
    "Chers utilisateurs notre plateforme est en travaux de maintenance",
  gestionmedical: "Gestion médicale",
  addvosaffilies: "ajouter vos affiliés",
  wait: "Veuillez patienter s'il vous plait vous serrez redirigé dans un instant ...",
  Historique_des_affiliations: "Historique des affiliations",
  paye: "Non Payé | Payé",
  dateEstPasse:
    "La date de début est passée du | --- La date de fin est passée du | --- La date de signature est passée du ",
  to: "au | à",
  statut:
    "Le statut de paiement du contrat est passée de | Le statut de paiement est passée de",
  expired: "L'expiration est passé de",
  info: "Information des affiliations",
  completeprofil: "Veuillez vérifier et compléter votre profil SVP.",
  unitaire: "Montant unitaire",
  produits: "Produits",
  numberpaid: "Nombre payé",
  numberstay: "Nombre restant",
  consult:
    "Veuillez consulter vos mails pour avoir vos accès a vos identifiants pour vous connecter et ajouter vos affiliés",
  patientinfo: "Informations du patient",
  personnecontact: "Personne à contacter",
  nothing: "Vous avez 0 affilié(s) à afficher",
  nodoctor: "Aucun medecin",
  canalmed:
    "Par quel canal avez vous entendu parler de Medicasure pour la 1ère fois ?",
  nooldpatient: "Vous n'avez aucun ancien patient",
  informationSouscripteur: "Informations du souscripteur",
  isloading: "Vous serez redirigé vers l'interface de paiement, un instant",
  moyenpaiement:
    "Selectionnez le moyen par quel vous désirez vous procéder au paiement svp",
  creditcard: "Carte de crédit",
  dejapaye: "Vous avez déjà procédé au paiement de cette affiliation",
  validationPrix: "Validations prix",
  validation: "Validations examens",
  addAffiliation: "Ajouter une affiliation",
  notpossible:
    "Vous ne pouvez plus ajouter de patient veuillez acheter une nouvelle CIM",
  merci: "Merci d'avoir choisi Medsurlink, Paiement effectué avec succès",
  initier: "Initier à nouveau le paiement",
  dejaom:
    "Avez vous déjà validé le paiement sur le popup ou taper #150*50# et validez ?",
  verification: "Sinon, la vérification automatique aura lieu dans : ",
  dejamomo: "Avez vous déjà validé le paiement au *126#",
  visualiser: "Visualiser",
  addPec: "Assigner un patient",
  addPecToInstitution: "Assigner un patient a un établissement",
  ligneTempsAMA: "ligne de temps des activités médicaux-administrative (AMA)",
  referentActivity: "Activité Medécin Referent",
  nomEtPrenomSouscripteur: "Nom et prenom du souscripteur",
  nomEtPrenomAffiliation: "Nom et prénom de l'affilié",
  detailsValidation: "Détails de la validation",
  ExamenPrixupdated: "Mise a jour des validations",
  Examenupdated: "Mise a jour des examens",
  ActivitesReferentCreated: "Activité médecin référent créé avec succès",
  suspendre: "Suspendre",
  activeContrat: "Activé",
  SubscriptionActive: "Affiliation activé",
  SubscriptionSuspend: "Affiliation suspendu",
  clotureAffiliation: "Cloture de l'affiliation",
  automatique: "Automatique",
  medecin_referent: "Medécin Reférent",
  gestionnaire: "Gestionnaire",
  cloturer: "Cloturer",
  Listsligne: "Listing des lignes de temps",
  ExamenUpdated: "Mise a jour du prix de l'examen effectué",
  validations: "Validations",
  totaux: "Totaux",
  Metrique: "Dashboard Metriques",
  add: "Ajouter",
  observation: "Observation",
  OldmedecinReferent: "Médécin courant",
  NewmedecinReferent: "Nouveau Médécin",
  transferer: "Transférer",
  changerMedReferent: "Transfert des patients",
  infopersonnelle: "Informations Personelles",
  ListingPatientSansIntervention: "Patients sans Intervention",
  alerteCreated: "Alerte créée avec succès",
  alertDeleted: "Alerte supprimée avec succès",
  contactPersonne: "Personne de contact",
  diagnostic_complementaire: "Diagnostic complementaires",
  PermissionAssigned: "Permission assignée avec succès",
  FeatureAssigned: "Fonctionnalité assignée avec succès",
  rgbac: "Rôles et Permissions",
  userPermissions: "Permission utilisateur",
  groupeCreated: "Groupe créé avec succès",
  groupes: "Groupes",
  groupe: "Groupe",
};
